<template>
  <el-dialog title="律师详情" :append-to-body="true" :visible.sync="visible" :show-close="false" width="700px" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false">
    <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click.stop="cancelModal"><i
      class="el-dialog__close el-icon el-icon-close"></i></button>
    <el-form :model="lawyer" size="small" :rules="rules" ref="lawyerForm">
      <el-form-item label="姓名" label-width="90px" prop="name">
        <el-input v-model="lawyer.name" autocomplete="off"></el-input>
      </el-form-item>
      <!--<el-form-item label="性别" label-width="120px">-->
        <!--<el-input v-model="lawyer.gender" autocomplete="off"></el-input>-->
      <!--</el-form-item>-->
      <el-form-item label="性别"  label-width="90px">
        <template>
          <el-radio v-model="lawyer.gender" label="1">男</el-radio>
          <el-radio v-model="lawyer.gender" label="2">女</el-radio>
        </template>
      </el-form-item>
      <el-form-item label="身份证号" label-width="90px" >
        <el-input v-model="lawyer.idcard" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="手机" label-width="90px">
        <el-input v-model="lawyer.mobile" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="律师证编号" label-width="90px" prop="code" >
        <!--<span v-if="lawyer.id === null || lawyer.id === ''">-->
           <el-input v-model="lawyer.code" autocomplete="off"></el-input>
        <!--</span>-->
        <!--<span v-else>-->
           <!--{{lawyer.code}}-->
        <!--</span>-->
      <!--<el-input v-model="lawyer.code" autocomplete="off"></el-input>-->
    </el-form-item>
      <!--<el-form-item label="律师类型"  label-width="90px" prop="type">-->
        <!--<template>-->
          <!--<el-radio v-model="lawyer.type" label="0">正式</el-radio>-->
          <!--<el-radio v-model="lawyer.type" label="1">实习</el-radio>-->
        <!--</template>-->
      <!--</el-form-item>-->
      <el-form-item label="执业机构" label-width="90px" prop="practicingInstitution">
        <el-input v-model="lawyer.practicingInstitution" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="所属律协" label-width="90px" prop="associationId">
        <!--<template>-->
          <!--<el-select :value="valueTitle" :clearable="clearable" @clear="clearHandle" >-->
            <!--<el-option :value="valueTitle" :label="valueTitle" class="options">-->
              <!--<el-tree style="padding-left: 10px"-->
                <!--id="tree-option"-->
                <!--ref="selectTree"-->
                <!--:accordion="accordion"-->
                <!--:data="options"-->
                <!--:props="props"-->
                <!--:node-key="props.value"-->
                <!--:default-expanded-keys="defaultExpandedKey"-->
                <!--@node-click="handleNodeClick">-->
              <!--</el-tree>-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</template>-->
        <el-select v-model="lawyer.associationId" @change="selectGet" filterable placeholder="请选择律协" ref="fieldSelect">
          <el-option
            v-for="item in assOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="邮箱" label-width="90px">
        <el-input v-model="lawyer.email" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="照片" label-width="90px">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :http-request="uploadLecturerPhoto"
          :before-upload="beforeUpload"
          :file-list="fileList"
          list-type="picture">
          <div class="el-upload__text"><i class="el-icon-upload" style="font-size: 18px"></i><span>上传</span></div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="loading" type="primary" :loading="true">保存中</el-button>
      <el-button v-else type="primary" @click="save('lawyerForm')">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import lawyer from '@/api/lawyer'
import association from '@/api/association'
import video from '@/api/video'
import store from '@/store/index'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    values: {
      type: Number,
      required: false,
      default: null
    },
    status: {
      type: Boolean,
      required: false,
      default: false
    },
    /* 配置项 */
    // props:{
    //   type: Object,
    //   default:()=>{
    //     return {
    //       value:'id',             // ID字段名
    //       label: 'name',         // 显示名称
    //       children: 'children'    // 子级字段名
    //     }
    //   }
    // },
    /* 选项列表数据(树形结构的对象数组) */
    // options:{
    //   type: Array,
    //   default: ()=>{ return [
    //     {
    //     id:1,
    //     pid:2,
    //     name: '省律协',
    //     children: [{
    //       id:2,
    //       pid:2,
    //       name: '郑州市律协',
    //       children: [{
    //         id:3,
    //         pid:2,
    //         name: '金水区律协',
    //       }]
    //     }, {
    //       id:4,
    //       pid:2,
    //       name: '新乡律协',
    //       children: [{
    //         id:5,
    //         pid:2,
    //         name: '辉县律协',
    //       }]
    //     }]
    //   }
    //   ] }
    // },
    /* 初始值 */
    // value:{
    //   type: Number,
    //   default: ()=>{ return null }
    // },
    // /* 可清空选项 */
    // clearable:{
    //   type:Boolean,
    //   default:()=>{ return true }
    // },
    // /* 自动收起 */
    // accordion:{
    //   type:Boolean,
    //   default:()=>{ return false }
    // },
    // /* 配置项 */
    // props:{
    //   type: Object,
    //   default:()=>{
    //     return {
    //       value:'id',             // ID字段名
    //       label: 'name',         // 显示名称
    //       children: 'children'    // 子级字段名
    //     }
    //   }
    // },
    // /* 选项列表数据(树形结构的对象数组) */
    // options:{
    //   type: Array,
    //   default: ()=>{ return [] }
    // },
    // /* 初始值 */
    // value:{
    //   type: Number,
    //   default: ()=>{ return null }
    // },
    // /* 可清空选项 */
    // clearable:{
    //   type:Boolean,
    //   default:()=>{ return true }
    // },
    // /* 自动收起 */
    // accordion:{
    //   type:Boolean,
    //   default:()=>{ return false }
    // }
  },
  data () {
    var validateSameCode = (rule, value, callback) => {
      lawyer.repear({code: this.lawyer.code, id: this.lawyer.id}).then(res => {
        // 不重复
        if (res.data.code === 0) {
          callback();
          // 重复
        } else if (res.data.code === 10000) {
          callback(new Error('此律师证编号已存在，请核对后再输入!'));
        }
      })
    };
    var isSelect = (rule, value, callback) => {
      // console.log(rule)
      if (value === null ) { //如果值是 0，提示用户选择正确的选项
        return callback(new Error("请正确选择所属律协"));
      } else {
        callback();
      }
    };
    return {
      checkCode: false,
      globalAssId: null,
      loading: false,
      photoParam: '',
      selectValue: true,
      assOptions: null,
      // 律师
      lawyer: {
        id: null,
        gender: '1',
        name: '',
        idcard: '',
        photo: '',
        mobile: '',
        code: '',
        lawFirm: '',
        loginDenied: '',
        associationId: null,
        type: '0',
        practicingInstitution: '',
        email: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入真实姓名', trigger: 'blur'},
        ],
        code: [
          { required: true, message: '请输入有效律师证编号', trigger: 'blur'},
          // { pattern: /^\d{17}$/, message: '长度为17位有效数字', trigger: 'blur' },
          { validator: validateSameCode, trigger: 'blur' }
        ],
        practicingInstitution: [
          {required: true, message: '请输入所在律所的正确名称', trigger: 'blur'},
        ],
        // type: [
        //   {required: true, message: '请选择律师类型', trigger: 'change'},
        // ],
        // valueTitle: [
        //   {required: true, trigger: 'change', validator: isSelect},
        // ]
        associationId: [
          {required: true, trigger: 'change', message: '请选择所属律协'},
        ]
      },
      valueId: null,    // 初始值
      valueTitle: '',
      defaultExpandedKey: [],
      fileList: [],
      url: 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/'
    }
  },
  methods: {
    initForm () {
      this.lawyer = {
        }
      if (this.$refs.lawyer) {
        this.$refs.lawyer.resetFields()
      }
    },
    cancelModal () {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit('update:visible', false)
    },
    reload () {
      // debugger
      // 登录人为省协会，新增律师
      // if (this.globalAssId == null && this.values === null) {
      //   this.selectValue = false
      //   this.findAssTree()
      // }
      // // 登录人为省协会，修改律师
      // if (this.globalAssId == null && this.values !== null) {
      //   this.selectValue = false
      //   this.findAssTree()
      //   this.loadLawyer()
      // }
      // // 登录人为下级协会，新增律师
      // if (this.globalAssId !== null && this.values === null) {
      //   this.selectValue = true
      //   this.loadAss()
      // }
      // // 登录人为下级协会，修改律师
      // if (this.globalAssId !== null && this.values !== null) {
      //   this.selectValue = true
      //   // this.loadAss()
      //   this.loadLawyer()
      // }
      // 新增
      if (this.status){
        // this.findAssTree()
        this.findAssData()
      } else {
        // 修改
        // this.findAssTree()
        this.findAssData()
        this.loadLawyer()
      }
    },
    loadLawyer () {
      // 查找律师详情
      lawyer.load({id: this.values}).then(res => {
        this.lawyer = res.data.data
        // console.log(this.lawyer )
        this.valueId = this.lawyer.associationId
        this.valueTitle = this.lawyer.lawFirm
        if (this.lawyer.photo!== '' && this.lawyer.photo!=null){
          this.fileList = []
          let upLoadImg = {
            name: this.lawyer.name,
            url: this.url + this.lawyer.photo
          }
          this.fileList.push(upLoadImg)
        }
      })
    },
    findAssTree () {
      // 树形数据
      association.find({name: ''}).then(res => {
        let list = res.data.data[0]
        this.options = []
        this.options.push(list)
      })
    },
    findAssData () {
      // list数据
      association.list().then(res => {
        this.assOptions = res.data.data
      })
    },
    loadAss () {
      association.load({id: this.globalAssId}).then(res => {
        this.valueId = this.globalAssId
        this.valueTitle = res.data.data.name
      })
    },
    //下拉框选中事件
    selectGet(id){//这个vId也就是value值
      this.valueId = id
      this.assOptions.forEach((item)=>{
        if (item.id === id) {
          this.valueTitle = item.name
        }
      });
    },
    save (formName) {
      this.loading = true
          let obj = {}
          if (this.lawyer.id === null){
            obj = {
              id: this.lawyer.id,
              gender: this.lawyer.gender,
              name: this.lawyer.name,
              idcard: this.lawyer.idcard,
              photo: this.lawyer.photo,
              mobile: this.lawyer.mobile,
              code: this.lawyer.code,
              lawFirm: this.valueTitle,
              type:this.lawyer.type,
              loginDenied: this.lawyer.loginDenied,
              associationId: this.valueId,
              practicingInstitution: this.lawyer.practicingInstitution,
              email: this.lawyer.email
            }
          } else {
            obj = {
              id: this.lawyer.id,
              gender: this.lawyer.gender,
              name: this.lawyer.name,
              idcard: this.lawyer.idcard,
              photo: this.lawyer.photo,
              mobile: this.lawyer.mobile,
              type:this.lawyer.type,
              lawFirm: this.valueTitle,
              loginDenied: this.lawyer.loginDenied,
              associationId: this.valueId,
              practicingInstitution: this.lawyer.practicingInstitution,
              email: this.lawyer.email,
              code: this.lawyer.code
            }
          }
          // console.log(obj)
          // lawyer.save(obj).then(res => {
          //   this.loading = false
          //   if (res.data.code===0){
          //     this.$message.success("操作成功！")
          //     this.$emit('update:visible', false)
          //     this.$emit('callFather')
          //   }else {
          //     this.$message.warning(res.data.message)
          //   }
          // })
      this.$refs[formName].validate((valid) => {
        if (valid) {
          lawyer.save(obj).then(res => {
            this.loading = false
            if (res.data.code===0){
              this.$message.success("操作成功！")
              this.$emit('update:visible', false)
              this.$emit('callFather')
            }else {
              this.$message.warning(res.data.message)
            }
          })
        } else {
          this.loading = false
          // console.log('error submit!!');
          return false;
        }
      });
    },
    initHandle(){
      if(this.valueId){
        this.valueTitle = this.$refs.selectTree.getNode(this.valueId).data[this.props.label]     // 初始化显示
        this.$refs.selectTree.setCurrentKey(this.valueId)       // 设置默认选中
        this.defaultExpandedKey = [this.valueId]      // 设置默认展开
      }
      this.initScroll()
    },
    // 初始化滚动条
    initScroll(){
      this.$nextTick(()=>{
        let scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0]
        let scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar')
        scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;'
        scrollBar.forEach(ele => ele.style.width = 0)
      })
    },
    // 切换选项
    handleNodeClick(node){
      this.valueTitle = node[this.props.label]
      this.valueId = node[this.props.value]
      this.$emit('getValue',this.valueId)
      this.defaultExpandedKey = []
    },
    // 清除选中
    clearHandle(){
      this.valueTitle = ''
      this.valueId = null
      this.defaultExpandedKey = []
      this.clearSelected()
      this.$emit('getValue',null)
    },
    // 清空选中样式
    clearSelected(){
      let allNode = document.querySelectorAll('#tree-option .el-tree-node')
      allNode.forEach((element)=>element.classList.remove('is-current'))
    },
    // 上传律师照片
    beforeUpload(file) {
      // console.log(file);
      //重新写一个表单上传的方法
      this.photoParam = new FormData();
      this.photoParam.append('file', file, file.name)
      // return false;
    },
    uploadLecturerPhoto () {
      video.uploadPhoto(this.photoParam).then(res => {
        if (res.data.code===0){
          this.$message.success('图片保存成功')
          let photoUrl = res.data.data
          photoUrl = photoUrl.replace(/\\/g,'/')
          // console.log(photoUrl)
          var index = photoUrl.lastIndexOf("/");
          let name = photoUrl.substring(index+1,photoUrl.length);
          let upLoadImg = {
            name: name,
            url: this.url + photoUrl
          }
          this.fileList.push(upLoadImg)
          this.lawyer.photo = photoUrl
        }else {
          this.$message.info('图片保存失败')
        }
      })
    },
  },
  // watch: {
  //   value(){
  //     this.valueId = this.value
  //     this.initHandle()
  //   }
  // },
  mounted() {
    // this.valueId = this.value,    // 初始值
    // this.initHandle()
    this.$nextTick(function() {
      this.$refs.fieldSelect.$refs.scrollbar.$el.classList.add(
        "scroll-opacity"
      );
    });
  },
  created () {
    if (store.getters.getAsId === '') {
      this.globalAssId = null
    }else {
      this.globalAssId = store.getters.getAsId
    }
    this.reload()
    // console.log(this.valueId)
  }
}
</script>
<!--<style scoped>-->
  <!--.el-scrollbar .el-scrollbar__view .el-select-dropdown__item{-->
    <!--height: auto;-->
    <!--max-height: 274px;-->
    <!--padding: 0;-->
    <!--overflow: hidden;-->
    <!--overflow-y: auto;-->
  <!--}-->
  <!--.el-select-dropdown__item.selected{-->
    <!--font-weight: normal;-->
  <!--}-->
  <!--ul li >>>.el-tree .el-tree-node__content{-->
    <!--height:auto;-->
    <!--padding: 0 20px;-->
  <!--}-->
  <!--.el-tree-node__label{-->
    <!--font-weight: normal;-->
  <!--}-->
  <!--.el-tree >>>.is-current .el-tree-node__label{-->
    <!--color: #409EFF;-->
    <!--font-weight: 700;-->
  <!--}-->
  <!--.el-tree >>>.is-current .el-tree-node__children .el-tree-node__label{-->
    <!--color:#606266;-->
    <!--font-weight: normal;-->
  <!--}-->
<!--</style>-->



// WEBPACK FOOTER //
// src/components/lawyer/lawyer/Lawyer.vue